// Entry point for the main application JavaScript
// This replaces the old Sprockets-based app/assets/javascripts/application.js

import '@hotwired/turbo-rails';
import * as ActionCable from '@rails/actioncable';
import jquery from 'jquery';

// Import Tom Select (modern replacement for Select2)
import TomSelect from 'tom-select';

// Import Bootstrap JavaScript for dropdowns, modals, etc.
import * as bootstrap from 'bootstrap';

// Load Stimulus controllers
import './controllers';

// Import page-specific JavaScript
import './consultant_applications';
import './analytics';
import './pages';
import './projects';
import './settings';
import './users';

// Make jQuery available globally (required for many plugins)
window.$ = jquery;
window.jQuery = jquery;
window.ActionCable = ActionCable;
window.App = window.App || {};
window.App.cable = window.App.cable || ActionCable.createConsumer();
// Make TomSelect available globally for easy access
window.TomSelect = TomSelect;
// Make Bootstrap available globally for programmatic access
window.bootstrap = bootstrap;